export default __webpack_public_path__ + "static/media/icon-node-tipo-leitura.692cf3fa.svg";